export enum LookupTypesEnum {
  MANUFACTURERS = "Manufacturers",
  ORDER_STATUSES = "OrderStatuses",
  ORDER_SUB_STATUSES = "OrderSubStatuses",
  ORDER_TYPES = "OrderTypes",
  SHIPS_TOS = "ShipTos",
  CATEGORIES = "Categories",
}
